export const ROOT_URL = 'https://mikecrapi.mikelegal.com/api';
export const DOCCHAT_ROOT_URL = 'https://docchatapi.mikelegal.com';
export const DSN =
  'https://fdb9476bc95e47749f15deae911a4c81@o115073.ingest.sentry.io/4505396212727808';

export const adobeToken = '49718952e165439ea8a9b7e5c9cc8336'; // Staging

export const sharableUrl = 'https://doccompare.mikelegal.com/viewer';

export const AUTH_URL = 'https://account.mikelegal.com';
// export const AUTH_URL = 'http://localhost:5173';

export const issuer = 'https://login.mikelegal.com'; // Zitadel

export const ACCOUNT_URL = 'https://accountapi.mikelegal.com';

export const clientId = '333807352648105987'; // accounts

export const metadata = {
  token_endpoint: `${issuer}/oauth/v2/token`,
};

export const isEnvStaging = ROOT_URL.includes('-staging');

export const source = 'doccompare';

export const PRODUCT_LINKS = {
  ACCOUNT: 'https://account.mikelegal.com/profile',
  CLM: 'https://clm.mikelegal.com/Dashboard',
  LITIGATOR: 'https://litigator.mikelegal.com/Dashboard',
  DOC_COMPARE: 'https://doccompare.mikelegal.com/doccompare',
  DOC_CHAT: 'https://doccompare.mikelegal.com/docchat',
};

// ======== staging urls ========

// export const ROOT_URL = 'https://mikecrapi-staging-v1.mikelegal.com/api';
// export const DOCCHAT_ROOT_URL = 'https://docchatapi-staging.mikelegal.com';

// // export const DOCCHAT_ROOT_URL = 'http://localhost:8000';
// export const DSN =
//   'https://fdb9476bc95e47749f15deae911a4c81@o115073.ingest.sentry.io/4505396212727808';
// // export const sharableUrl='http://localhost:5173/viewer'; //localHost
// // export const adobeToken='8c0cd670273d451cbc9b351b11d22318'; //localHost

// export const adobeToken = '49718952e165439ea8a9b7e5c9cc8336'; // Staging
// export const sharableUrl = 'https://doccomparedev.mikelegal.com/viewer'; // Staging
// // export const sharableUrl = 'https://doccompare.mikelegal.com/viewer'; //Production

// export const AUTH_URL = 'https://account-staging.mikelegal.com';
// // export const AUTH_URL = 'http://localhost:5173';

// export const issuer = 'https://auth-staging.mikelegal.com'; // Zitadel

// export const ACCOUNT_URL = 'https://accountapi-staging.mikelegal.com';

// export const clientId = '333600799483560196'; // accounts

// export const metadata = {
//   token_endpoint: `${issuer}/oauth/v2/token`,
// };

// export const isEnvStaging = ROOT_URL.includes('-staging');

// export const source = 'doccompare';

// export const PRODUCT_LINKS = {
//   ACCOUNT: 'https://account-staging.mikelegal.com/profile',
//   CLM: 'https://clm-staging.mikelegal.com/Dashboard',
//   LITIGATOR: 'https://mikelitigatordev.mikelegal.com/Dashboard',
//   // DOC_COMPARE: 'http://localhost:5173/doccompare',
//   // DOC_CHAT: 'http://localhost:5173/docchat',
//   DOC_COMPARE: 'https://doccomparedev.mikelegal.com/doccompare',
//   DOC_CHAT: 'https://doccomparedev.mikelegal.com/docchat',
// };
